import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=71fa9e13&"
import script from "./Favorite.vue?vue&type=script&lang=js&"
export * from "./Favorite.vue?vue&type=script&lang=js&"
import style0 from "./Favorite.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports